import React, { useEffect, useState } from "react";
import Constants from "../../../Constants";
import APIUrls from "../../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import { postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import SuccessMessage from "../../../components/SuccessMessage";
import { logError } from "../../../services/authApiRoutes/APImethods";
import $ from "jquery";

export default function UserPermissionsSetting(props) {
  const {integrationUsers,setPermissionStatus}=props
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [userList,setUserList]=useState([])
  const theme = aaaSelected ? "dark" : "";
  const accountPermission = useSelector(
		(updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data,
	  ).value;

  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  useEffect(()=>{
    setUserList(integrationUsers)
  },[integrationUsers])
  useEffect(()=>{
    if(userList && userList.length > 0 ){
     let user=userList.find(data=>data.userId===accountPermission?.user?.userId)
     setPermissionStatus(checkUserAccess(user))
    }
  },[userList])


  const userPermissionColumns = [
    {
      id: "user.name",
      name: "Name",
      //maxWidth: "350px",
      selector: (user) => user.firstName + " " + user.lastName,
      sortable: true,
      cell: (user) => user.firstName + " " + user.lastName,
    },
    {
      id: "user.role",
      name: "Role",
      //maxWidth: "350px",
      selector: (user) => user.roleSet.displayName,
      sortable: true,
      cell: (user) => user.roleSet.displayName,
    },
    {
      id: "user.userGroupMembers",
      name: "Department",
      //maxWidth: "350px",
      wrap: true,
      selector: (user) => user.userGroupMembers,
      sortable: true,
      cell: (user) => new String(user.userGroupMembers.map(userGroupMember => userGroupMember.userGroup.name).join(', '))
    },
    {
      id: "user.permissions",
      name: props.accessName,
      //maxWidth: "350px",
      selector: (user) => user.permissions,
      cell: (user) => (
        <div className="flex-center gap-10">
          <div className="yes-no-customradio">
            <input type="radio" className="form-check-input" name={"radio-" + user.userId} id={user.userId + "-yes"} defaultChecked={isDefaultChecked(user) ? true : false} onChange={() => changeUserPermission(user, true)}/>
            <label className="form-check-label" htmlFor={user.userId+ "-yes"}>Yes</label>
          </div>
          <div className="yes-no-customradio">
            <input type="radio" className="form-check-input" name={"radio-" + user.userId} id={user.userId+ "-no"} defaultChecked={!isDefaultChecked(user) ? true : false} onChange={() => changeUserPermission(user, false)}/>
            <label className="form-check-label" htmlFor={user.userId+ "-no"}>No</label>
          </div>
        </div>
      )
    }
  ];

  const isDefaultChecked = (user) => {
    if (props.settingType === Constants.MARKETOREST) {
      return user.permissions?.MARKETOREST_ACCESS
    } else if (props.settingType === Constants.ELOQUA) {
      return user.permissions?.ELOQUA_ACCESS
    } else if (props.settingType === Constants.BRIGHTCOVE) {
      return user.permissions?.BRIGHTCOVE_ACCESS
    } else if (props.settingType === Constants.PARDOT) {
      return user.permissions?.PARDOT_ACCESS
    } else if (props.settingType === Constants.VIDYARD) {
      return user.permissions?.VIDYARD_ACCESS
    } else if (props.settingType === Constants.UBERFLIP) {
      return user.permissions?.UBERFLIP_ACCESS
    } else if (props.settingType === Constants.EXACTTARGET) {
      return user.permissions?.EXACTTARGET_ACCESS
    }
  }

  const changeUserPermission = (user, isYes) => {
    let serviceType;
    if (props.settingType === Constants.MARKETOREST && user.permissions[Constants.MARKETOREST_ACCESS] !== undefined) {
      user.permissions[Constants.MARKETOREST_ACCESS] = isYes;
      serviceType = Constants.MARKETOREST
    } else if (props.settingType === Constants.ELOQUA && user.permissions[Constants.ELOQUA_ACCESS] !== undefined) {
      user.permissions[Constants.ELOQUA_ACCESS] = isYes;
      serviceType = Constants.ELOQUA
    } else if (props.settingType === Constants.BRIGHTCOVE && user.permissions[Constants.BRIGHTCOVE_ACCESS] !== undefined) {
      user.permissions[Constants.BRIGHTCOVE_ACCESS] = isYes;
      serviceType = Constants.BRIGHTCOVE
    } else if (props.settingType === Constants.PARDOT && user.permissions[Constants.PARDOT_ACCESS] !== undefined) {
      user.permissions[Constants.PARDOT_ACCESS] = isYes;
      serviceType = Constants.PARDOT
    } else if (props.settingType === Constants.VIDYARD && user.permissions[Constants.VIDYARD_ACCESS] !== undefined) {
      user.permissions[Constants.VIDYARD_ACCESS] = isYes;
      serviceType = Constants.VIDYARD
    } else if (props.settingType === Constants.UBERFLIP && user.permissions[Constants.UBERFLIP_ACCESS] !== undefined) {
      user.permissions[Constants.UBERFLIP_ACCESS] = isYes;
      serviceType = Constants.UBERFLIP
    } else if (props.settingType === Constants.EXACTTARGET && user.permissions[Constants.EXACTTARGET_ACCESS] !== undefined) {
      user.permissions[Constants.EXACTTARGET_ACCESS] = isYes;
      serviceType = Constants.EXACTTARGET
    }
    
    postAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_ACCESS_PERMISSION(user.userId, serviceType), user
    ).then((res) => {
      props.getUser();
      setSuccessMessage("Permission updated successfully.");
    }).catch((err) => {
      const errorMessage = "err - ";
      logError(errorMessage, err); 
        })
  }

  useEffect(()=>{
    if(successMessage!==Constants.BLANK){
      setSuccessMessage(successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
      },5000);
    }
  },[successMessage]);

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
  };

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");  
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
   })


   const checkUserAccess=(user)=>{
    let status=false;
    if (props.settingType === Constants.MARKETOREST && user.permissions[Constants.MARKETOREST_ACCESS] !== undefined) {
      status=user.permissions[Constants.MARKETOREST_ACCESS]
    } else if (props.settingType === Constants.ELOQUA && user.permissions[Constants.ELOQUA_ACCESS] !== undefined) {
      status=user.permissions[Constants.ELOQUA_ACCESS]
    } else if (props.settingType === Constants.BRIGHTCOVE && user.permissions[Constants.BRIGHTCOVE_ACCESS] !== undefined) {
      status=user.permissions[Constants.BRIGHTCOVE_ACCESS]
    } else if (props.settingType === Constants.PARDOT && user.permissions[Constants.PARDOT_ACCESS] !== undefined) {
      status=user.permissions[Constants.PARDOT_ACCESS]
    } else if (props.settingType === Constants.VIDYARD && user.permissions[Constants.VIDYARD_ACCESS] !== undefined) {
      status=user.permissions[Constants.VIDYARD_ACCESS]
    } else if (props.settingType === Constants.UBERFLIP && user.permissions[Constants.UBERFLIP_ACCESS] !== undefined) {
      status=user.permissions[Constants.UBERFLIP_ACCESS]
    } else if (props.settingType === Constants.EXACTTARGET && user.permissions[Constants.EXACTTARGET_ACCESS] !== undefined) {
      status=user.permissions[Constants.EXACTTARGET_ACCESS]
    }
    return status;
   }

  return(
    <>
    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}
    <div className="datatable-block custom_width">
      <DataTable 
        columns={userPermissionColumns}
        data={props.integrationUsers} 
        highlightOnHover
        responsive
        striped
        selectableRowsHighlight={true}
        defaultSortFieldId={1}
        theme={theme}
        progressPending={props.pendingPermission}
        onSort={handleSort}
      />
      </div>
      {/* <div className="flex flex-end mar-top30">
          <button className="blue-btn active">Save</button>
      </div> */}
    </>
    
  );

}